import React from "react";

export const mergeRefs = (refs: React.MutableRefObject<any>[]) => (node: any) =>
  refs.filter((ref) => !!ref).forEach((ref) => (ref.current = node));
